var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "400px",
        "close-on-click-modal": false,
        "show-close": false,
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("div", { staticClass: "dialog_title" }, [
                _c("div", { staticClass: "title" }, [_vm._v("知识点小测验")]),
                _vm._v(" "),
                _c("div", { staticClass: "timers" }, [
                  _vm._v("剩余答题时间："),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.remainingTime) + "s")
                  ])
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm.question && _vm.question.questionContent
        ? _c("div", { staticStyle: { "font-size": "15px" } }, [
            _vm._v(
              _vm._s(_vm.type() + _vm.question.questionContent.questionStem)
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question &&
      _vm.question.questionContent &&
      _vm.question.questionContent.imageUrlList
        ? _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            _vm._l(_vm.question.questionContent.imageUrlList, function(
              imgUrl,
              index
            ) {
              return _c("el-image", {
                key: index,
                staticStyle: { width: "100px", height: "100px" },
                attrs: { src: imgUrl, fit: "cover" },
                on: {
                  click: function($event) {
                    return _vm.picturePreview(imgUrl)
                  }
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "choicess" },
        _vm._l(_vm.choices, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              class: { item: true, active: item.checked },
              on: {
                click: function($event) {
                  return _vm.updateChecked(index)
                }
              }
            },
            [
              _c("span", [_vm._v(_vm._s(item.content))]),
              _vm._v(" "),
              item.checked
                ? _c("img", {
                    staticStyle: { width: "18px", height: "18px" },
                    attrs: {
                      src: require("@/assets/images/correct.png"),
                      alt: ""
                    }
                  })
                : _c("div", {
                    staticStyle: { "min-width": "18px", "min-height": "18px" }
                  })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          class: { "submit-btn": true, active: _vm.btnDisabled },
          attrs: { type: "primary" },
          on: { click: _vm.submit }
        },
        [_vm._v("提交")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f56d7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f56d7d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/videoDetail/knowledgeDialog.vue
// module id = 1574
// module chunks = 0